import Vue from 'vue'

import VueRouter from 'vue-router'
import Home from '@/views/home/Home.vue'
import AUTHORITY from '@/axios/authority/Authority'
// import ExperienceRoutes from "@/modules/experianceAI/router/index.js";
// 公共组件
import IconBase from '@/components/icons/IconBase.vue'
import GatHead from '@/components/common/GatHead.vue'
import GatFooter from '@/components/common/GatFooter.vue'

// markdown编辑器
import editorMd from '@/components/common/editorMd.vue'

import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// use
Vue.use(mavonEditor)

Vue.use(VueRouter)
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}

// 全局注册控件
Vue.component('icon-base', IconBase)
Vue.component('gat-head', GatHead)
Vue.component('gat-footer', GatFooter)
Vue.component('editor-md', editorMd)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    // redirect: '/home',
  },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: Home,
  //   // redirect: '/',
  // },
  {
    path: '/authority',
    name: 'authority',
    component: () => import('@/views/Authority.vue'),
  },
  {
    path: '/accountsetting',
    name: 'account-setting',
    component: () => import('@/views/AccountSetting.vue'),
  },
  {
    path: '/test/audio/editor',
    name: 'audio-editor',
    component: () => import('@/views/test/audioEditor.vue'),
  },
  {
    path: '/game/editor',
    name: 'game-editor',
    component: () => import('@/views/game/GameEditorHome.vue'),
  },
  {
    // 回收站
    path: '/recycleBin',
    name: 'recycle-bin',
    component: () => import('@/views/recycle/recycleBin.vue'),
  },
  {
    // 编辑器积木帮助文档
    path: '/projects/aiTEditor/helpdocument',
    name: 'help-document',
    component: () => import('@/views/help/aiTEditorHelp/HelpDocument.vue'),
  },
  {
    path: '/projects/base/helpdocument',
    name: 'base-help-document',
    component: () =>
      import('@/views/help/baseBlockEditorHelp/BaseBlockHelpDocument.vue'),
    // redirect: "/projects/helpdocument/operators", // 设置默认打开的页面
  },
  {
    path: '/projects/robot/a/helpdocument',
    name: 'hardware-help-document',
    component: () =>
      import('@/views/help/hardwareEditorHelp/HardwareHelpDocument.vue'),
  },
  {
    path: '/projects/robot/b/helpdocument',
    name: 'hardware-help-b-document',
    component: () =>
      import('@/views/help/hardwareEditorHelpB/HardwareHelpDocumentB.vue'),
  },

  {
    // 个人空间
    path: '/aiTEditor/projectsList',
    name: 'projects-list',
    component: () => import('@/views/personalSpace/ProjectsList'),
  },
  {
    // 教学中心
    path: '/teaching/center/code',
    name: 'teaching-center-code',
    component: () => import('@/views/teachingCenter/TeachingCenterIndex.vue'),
  },
  {
    // Ai-T编辑器-积木模式
    // path: "/ai/editor/:projectId",
    path: '/ai/editor',
    name: 'ai-editor',
    component: () => import('@/views/projects/AiTEditor/EditorHome'),
  },
  {
    // Ai-T编辑器-代码模式
    path: '/ai/python/editor',
    name: 'ai-python-editor',
    component: () =>
      import('@/views/projects/AiTPythonEditor/AiTPythonEditorHome.vue'),
  },
  {
    // 基础积木编辑器
    path: '/baseBlock/editor',
    name: 'baseBlock-editor',
    component: () =>
      import('@/views/projects/baseBlockEditor/BaseBlockEditorHome.vue'),
  },
  {
    // 硬件积木-小聪编辑器
    path: '/hardwareBlock/editor',
    name: 'hardwareBlock-editor',
    component: () =>
      import(
        '@/views/projects/hardwareBlockEditorA/HardwareBlockEditorHome.vue'
      ),
  },
  {
    // 硬件积木-小智编辑器
    path: '/hardwareBlock/editorB',
    name: 'hardwareBlock-editor-B',
    component: () =>
      import(
        '@/views/projects/hardwareBlockEditorB/HardwareBlockEditorHomeB.vue'
      ),
  },
  {
    // python编辑器
    path: '/python/editor',
    name: 'python-editor',
    component: () =>
      import('@/views/projects/pythonEditor/PythonEditorHome.vue'),
  },
  {
    //数据集大厅
    path: '/pretrain/datasetlobby',
    name: 'dataset-lobby',
    component: () => import('@/views/datasetLobby/DatasetLobby'),
  },
  {
    // 数据集大厅
    path: '/pretrain/datasetlobby/datasetPreview',
    name: 'dataset-preview',
    component: () => import('@/views/datasetLobby/DatasetPreview'),
    props: (route) => ({
      datasetId: route.query.datasetid,
    }),
  },
  {
    //摄像头采集图片页面
    path: '/pretrain/CameraCollectionImg',
    name: 'camera-collection-img',
    component: () => import('@/components/pretrain/CameraCollectionImg'),
  },
  {
    // 硬件管理中心
    path: '/hardwareCenter',
    name: 'hardware-center',
    component: () => import('@/views/hardwareManagement/HardwareCenter'),
  },
  {
    // 硬件管理详情
    path: '/hardwareDetails',
    name: 'hardware-details',
    component: () => import('@/views/hardwareManagement/HardwareDetails'),
  },
  {
    // 项目实训-首页
    path: '/training/trainingproject',
    name: 'projects-training-project',
    component: () => import('@/views/trainingCenter/TrainingProject.vue'),
  },
  {
    // 项目实训-详情页
    path: '/training/cursedetails',
    name: 'course-details',
    component: () => import('@/views/trainingCenter/CourseDetails.vue'),
  },
  {
    // 项目实训-实训模型
    path: '/training/trainingModel',
    name: 'training-model',
    component: () =>
      import('@/views/trainingCenter/MarkCenter/TrainingModel.vue'),
  },
  // {
  //   // 项目实训-标注页面
  //   path: '/training/markCenterHome',
  //   name: 'mark-center-home',
  //   component: () =>
  //     import('@/views/trainingCenter/MarkCenter/MarkCenterHome.vue'),
  // },
  // {
  //   // 项目实训-图片标注
  //   path: '/training/imageTagging',
  //   name: 'image-tagging',
  //   component: () => import('@/views/trainingCenter/MarkCenter/ImageTagging.vue'),
  // },
  {
    // 项目实训-作业
    path: '/training/publishList',
    name: 'publish-list',
    component: () =>
      import('@/views/trainingCenter/MarkCenter/PublishList.vue'),
  },
  {
    // 实训-编辑器-积木模式
    path: '/training/editor/block',
    name: 'training-editor-block',
    component: () => import('@/views/trainingCenter/AiEditor/BlocklyHome.vue'),
    props: (route) => ({
      trainingId: route.query.trainingId,
      createBy: route.query.createBy,
    }),
  },
  {
    // 实训-编辑器-代码模式
    path: '/training/editor/ai/python',
    name: 'training-editor-ai-python',
    component: () =>
      import('@/views/trainingCenter/AiPythonEditor/trainingAiPythonHome.vue'),
    props: (route) => ({
      trainingId: route.query.trainingId,
      createBy: route.query.createBy,
    }),
  },
  {
    // 实训-基础积木编辑器（海龟库）
    path: '/training/editor/baseBlock',
    name: 'training-editor-baseBlock',
    component: () =>
      import(
        '@/views/trainingCenter/baseBlockEditor/TrainingBaseBlockHome.vue'
      ),
    props: (route) => ({
      trainingId: route.query.trainingId,
      createBy: route.query.createBy,
    }),
  },
  {
    // 模型评估报告
    path: '/pretrain/ModelAssessmentReport',
    name: 'model-assessment-report',
    component: () => import('@/components/pretrain/ModelAssessmentReport'),
  },
  {
    // 训练模型
    path: '/pretrain/:modeltype',
    name: 'pretrain',
    component: () => import('@/views/pretrain/PretrainBase'),
    redirect: (route) => {
      // var r = { name: 'model-list', params: {} },
      var r = { name: 'dataset-list', params: {} },
        modeltype = route.params.modeltype
      r.params.modeltype = modeltype ? modeltype : '1'

      return r
    },
    props: (route) => ({
      modelType: route.params.modelType,
    }),
    children: [
      {
        // 我的模型
        path: 'model/list',
        name: 'model-list',
        component: () => import('@/views/pretrain/ModelList'),
      },
      {
        // 模型操作
        /**
         * 创建模型：create
         * 训练模型：training
         * 校验模型：verify
         * 发布模型：release
         * */
        path: 'model/operate',
        name: 'model-operate',
        component: () => import('@/views/pretrain/ModelOperate'),
        props: (route) => ({
          operate: route.query.operate,
        }),
      },
      {
        // 我的数据集
        path: 'dataset/list',
        name: 'dataset-list',
        component: () => import('@/views/pretrain/DatasetList'),
      },
      {
        // 创建数据集
        path: 'dataset/create',
        name: 'dataset-create',
        component: () => import('@/views/pretrain/DatasetCreate'),
      },
      {
        // 图片分类
        path: 'dataset/classify',
        name: 'dataset-classify',
        component: () => import('@/views/pretrain/DatasetClassify'),
      },
      {
        // 标注数据
        path: 'dataset/label',
        name: 'dataset-label',
        component: () => import('@/views/pretrain/DatasetLabel'),
      },
      {
        // 文本分类
        path: 'dataset/textCategorization',
        name: 'dataset-categorization',
        component: () => import('@/views/pretrain/DatasetTextCategorization'),
      },
      {
        // 文本标注
        path: 'dataset/textAnnotation',
        name: 'dataset-annotation',
        component: () => import('@/views/pretrain/DatasetTextAnnotation'),
      },
      {
        // 音频分类
        path: 'dataset/audioCategorization',
        name: 'dataset-audioCategorization',
        component: () => import('@/views/pretrain/DatasetAudioCategorization'),
      },
      {
        // 音频标注
        path: 'dataset/audioAnnotation',
        name: 'dataset-audioAnnotation',
        component: () => import('@/views/pretrain/DatasetAudioAnnotation'),
      },
    ],
  },
  {
    // 行业应用
    path: '/industral/application/index',
    name: 'application-index',
    component: () =>
      import('@/views/industralApplication/ApplicationIndex.vue'),
  },
  {
    // 直播页面
    path: '/industral/application/live',
    name: 'application-live',
    component: () => import('@/views/industralApplication/ApplicationLive.vue'),
  },
  {
    // 成绩单
    path: '/reportCard',
    name: 'report-card',
    component: () => import('@/views/reportCard/reportCard.vue'),
  },
  {
    // 成绩单管理页
    path: '/reportCard/management',
    name: 'report-card-manage',
    component: () => import('@/views/reportCard/CardManagement.vue'),
  },
  {
    // 新手指引
    path: '/guide/document',
    name: 'guide-document',
    component: () => import('@/views/guide/GuideDocument.vue'),
  },
  {
    // 上传资源、转义
    path: '/upload/source',
    name: 'upload-source',
    component: () =>
      import(/* webpackChunkName: "upload" */ '@/views/upload/Upload.vue'),
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
]

const allRoutes = [...routes]
// const allRoutes = [...routes, ...ExperienceRoutes];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: allRoutes,
  // 滚动至顶部，部分页面会出现滚动条位置状态留存
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})


router.beforeEach(async (to, from, next) => {
  // console.log(to, from)
  let path = to.path

  //origin 用于设置头部gatHeader组件的选中样式
  let IF_AUTHORITY = window.gtaAiConfig.IF_AUTHORITY //是否已经授权了
  if(!IF_AUTHORITY){
    IF_AUTHORITY = sessionStorage.IF_AUTHORITY == 'true' ? true : false
  }

  if (!IF_AUTHORITY) {
    //未授权时
    let res = await Check()
    if (res && res.isSuccess) {
      IF_AUTHORITY = true
      sessionStorage.IF_AUTHORITY = 'true'
    } else if (res && res.message) {
      IF_AUTHORITY = false
      sessionStorage.IF_AUTHORITY = 'false'
      window.ApplyCode = res.applyId
    }
  } 


  if (!IF_AUTHORITY) {
    if (to.path === '/authority') {
      next()
    } else {
      next('/authority')
    }
  } else {
    if (/authority/.test(path)) {
      next('/')
    } else {
      next()
    }
  }
})
//验证是否已经授权
async function Check() {
  const res = AUTHORITY.authorityAbout()
  return res
}
export default router
